import router from '@/router/router';

export function open_blank(route) {
    const { href } = router.resolve(route);
    window.open(href, '_blank');
}